module.exports = __webpack_public_path__ + "static/media/001-Ueberzeugen_ID_1.ae880653.mp3";